/**
 * feedback-bubble-pos.ts — Vị trí nút bong bóng "Góp ý": kéo thả được, tự dính vào cạnh trái / phải, nhớ ở trình duyệt.
 * Hàm thuần (có test) — phần React nằm ở feedback-bubble.tsx.
 */
export type BubbleSide = 'left' | 'right'
export interface BubblePos { side: BubbleSide; /** khoảng cách từ đáy màn hình tới đáy nút (px) */ bottom: number }

/** Chiều cao nút (px). Nút có chữ "Gửi Feedback" nên bề rộng tự co giãn. */
export const BUBBLE_SIZE = 48
export const EDGE_GAP = 12
export const POS_KEY = 'ecdp:feedback-bubble-pos'

/** Giữ nút trong màn hình (chừa mép), kể cả khi xoay màn hình / thu nhỏ cửa sổ. */
export function clampBottom(bottom: number, viewportH: number): number {
  const max = Math.max(EDGE_GAP, viewportH - BUBBLE_SIZE - EDGE_GAP)
  return Math.min(max, Math.max(EDGE_GAP, Math.round(bottom)))
}

/** Thả nút tại toạ độ (x, y) góc trái-trên → dính vào cạnh gần nhất, giữ độ cao. `width`: bề rộng thật của nút (có chữ nên rộng hơn cao). */
export function snapPosition(x: number, y: number, viewportW: number, viewportH: number, width = BUBBLE_SIZE): BubblePos {
  const centerX = x + width / 2
  return {
    side: centerX < viewportW / 2 ? 'left' : 'right',
    bottom: clampBottom(viewportH - (y + BUBBLE_SIZE), viewportH),
  }
}

export function parsePos(raw: string | null | undefined): BubblePos | null {
  if (!raw) return null
  try {
    const v = JSON.parse(raw) as Partial<BubblePos>
    if ((v.side !== 'left' && v.side !== 'right') || typeof v.bottom !== 'number' || !Number.isFinite(v.bottom)) return null
    return { side: v.side, bottom: v.bottom }
  } catch {
    return null
  }
}

/** Máy tính và điện thoại nhớ vị trí RIÊNG (điện thoại là cái tab ép vào mép, máy tính là nút nổi). */
const keyFor = (mobile: boolean) => (mobile ? `${POS_KEY}:m` : POS_KEY)

export function loadPos(mobile = false): BubblePos | null {
  try { return parsePos(window.localStorage.getItem(keyFor(mobile))) } catch { return null }
}

export function savePos(pos: BubblePos, mobile = false): void {
  try { window.localStorage.setItem(keyFor(mobile), JSON.stringify(pos)) } catch { /* trình duyệt chặn lưu → bỏ qua */ }
}
